var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubLoationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.558,
    height: 21.523,
    viewBox: "0 0 19.558 21.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(-22.475 -8.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M22.058,7.109c0,1.441-3.93,2.609-8.779,2.609S4.5,8.551,4.5,7.109,8.43,4.5,13.279,4.5",
    transform: "translate(18.975 19.23)",
    fill: "none",
    stroke: "#157fef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M12.2,8.352A3.852,3.852,0,1,1,8.352,4.5,3.852,3.852,0,0,1,12.2,8.352Z",
    transform: "translate(23.528 4.925)",
    fill: "none",
    stroke: "#157fef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M34.9,19.452V27.98",
    transform: "translate(-2.647 -2.323)",
    fill: "none",
    stroke: "#157fef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubLoationIcon);
export default __webpack_public_path__ + "static/media/subLoationIcon.2ba5c01046c3082555157019971af54e.svg";
export { ForwardRef as ReactComponent };